import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './feature/admin/AdminDashboard';
import SharePostPage from './feature/share/SharePostPage';
import ShareLayerPage from './feature/share/ShareLayerPage';
import AppDownloadPage from './feature/app-download/AppDownloadPage';
import PrivacyPage from './feature/privacy/PrivacyPage';
import DeleteAccountPage from './feature/delete-account/DeleteAccountPage';
import StormbytePage from './feature/stormbyte/StormbytePage';
import TermsPage from './feature/terms/TermsPage';
import EventDetailPage from './feature/event-detail/EventDetailPage';
import FullEventDetailPage from './feature/event-detail/FullEventDetailPage';
import LivestreamViewerPage from './feature/livestream/LivestreamViewerPage';
import BlogListPage from './feature/blog/BlogListPage';
import BlogDetailPage from './feature/blog/BlogDetailPage';
import TestVideoPage from './TestVideoPage';
import { RealtimeProvider } from './realtime/RealtimeProvider';
import { WS_BASE_URL } from './api/constants';
import './App.css';

function App() {
  return (
    <RealtimeProvider baseUrl={WS_BASE_URL} token={null}>
      <Router>
        <Routes>
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/share/post/:shareId" element={<SharePostPage />} />
          <Route path="/share/layer/:shareId" element={<ShareLayerPage />} />
          <Route path="/event/:eventId" element={<EventDetailPage />} />
          <Route path="/event/:eventId/details" element={<FullEventDetailPage />} />
          <Route path="/livestream/:shareId" element={<LivestreamViewerPage />} />
          <Route path="/download" element={<AppDownloadPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/stormbyte" element={<StormbytePage />} />
          <Route path="/" element={<AppDownloadPage />} />
        </Routes>
      </Router>
    </RealtimeProvider>
  );
}

export default App;